import { PatientProfileItem } from "./PatientProfileItem";

/**
 * 患者プロフィール
 */
export class PatientProfileInformation {
  constructor(public items: PatientProfileItem[], public isInvalid: boolean = false, public isUpdated: boolean = false) {
  }

  public clone(): PatientProfileInformation {
    const items = this.cloneItems();
    return new PatientProfileInformation(items, this.isInvalid, this.isUpdated);
  }

  private cloneItems(): PatientProfileItem[] {
    if (!this.items) { return null; }
    const items: PatientProfileItem[] = [];
    for (const item of this.items) {
      items.push(item.clone());
    }
    return items;
  }
}
